import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import ListSelectedItems from '../common/ListSelectedItems';
import ImageItem from './ImageItem';
import Adjustment from './Adjustment';
import Settings from './Settings';

import { Info } from 'lib/styles';

const Container = styled.div`
	padding: 16px 40px;
`;

const Image = props => {
	const {
		t,
		activeIndex,
		viewSettings,
		data: {
			data,
			options
		}
	} = props;
	const activeImageData = activeIndex in data ? data[activeIndex] : false;
	const activeImageDataWithChanges = {
		...activeImageData,
		...props.unsavedChanges,
	};

	const items = data.map((image, index) => ({
		id: image.file,
		selected: activeIndex === index,
		element: <ImageItem {...image} />
	}));

	let infoText = props.viewItems ?
		t('controls/image/info/select') :
		activeIndex === -1 ?
			t('controls/image/info/default') :
			t('controls/image/info/align');

	if (data.length > 4 && (props.viewItems || activeIndex === -1)) {
		infoText += t('controls/image/info/maxlength');
	}

	return (
		<Container>
			{
				viewSettings &&
				<Settings
				  imageCount={data.length}
				  data={data}
				  options={options}
				  updateSettingsHandler={props.updateSettingsHandler}
				/>
			}
			{
				!viewSettings &&
				<React.Fragment>
				  <ListSelectedItems
				    viewItems={props.viewItems}
				    activeIndex={props.activeIndex}
				    activeIndexHandler={props.activeIndexHandler}
				    viewItemsText="controls/image/select images"
				    viewItemsToggleHandler={props.viewItemsToggleHandler}
				    saveHandler={props.saveHandler}
				    onSortEndHandler={props.onSortEndHandler}
				    items={items}
				  />
				  { activeIndex !== -1 &&
					<Adjustment
					  {...activeImageDataWithChanges}
					  changesHandler={props.changesHandler}
					/>}
				  <Info
				    icon="light-bulb"
				    fill="orange"
				    info={infoText}
				  />
				</React.Fragment>
			}
		</Container>
	)
}

Image.propTypes = {
	t: PropTypes.func,
	data: PropTypes.shape({
		data: PropTypes.arrayOf(PropTypes.shape({
			id: PropTypes.string,
			conversions: PropTypes.shape({
				large: PropTypes.string,
				medium: PropTypes.string,
				small: PropTypes.string,
				min: PropTypes.string,
				xs: PropTypes.string,
			}),
			position: PropTypes.arrayOf(PropTypes.number),
			size: PropTypes.oneOf(['cover', 'contain']),
			scale: PropTypes.number,
		})),
		id: PropTypes.string,
		type: PropTypes.oneOf(['image']),
	}),
	unsavedChanges: PropTypes.object,
	viewSettings: PropTypes.bool,
	activeIndex: PropTypes.number,
	viewItems: PropTypes.bool,
	changesHandler: PropTypes.func,
	activeIndexHandler: PropTypes.func,
	viewItemsToggleHandler: PropTypes.func,
	saveHandler: PropTypes.func,
	onSortEndHandler: PropTypes.func,
	updateSettingsHandler: PropTypes.func,
}

export default translate('translations')(Image)
